import { Component, Input } from '@angular/core';
import { CourseConstants } from '../../constants/course.constants';
import { CourseService } from '../../services/course.service';
import { AssignmentGroupService } from '../../../system-admin/assignment-group/services/assignment-group.service';
import { SessionStatusConstants } from '../../constants/sessionStatus.constants';
import { EnrollmentFormatsConstants } from '../../constants/sessionEnrollment.constants';
import { DatePipe } from '@angular/common';
import { CoursePersistenceService } from '../../services/course-persistence.service';
import { CommonService } from '../../../../app/shared/services/common.service';
import { SessionDetails } from '../../models/session-details';
import { EnrollSessionData } from '../../models/enroll-session-data';
import { MessageService } from 'primeng/api';
import { PanelHubStateChangedEvent } from '../../../shared-components/panel-hub/models/panel-hub-state-changed-event';
import { PanelHubEventType } from '../../../shared-components/panel-hub/enums/panel-hub-eventtype';
import { PanelHubConfiguration } from '../../../shared-components/panel-hub/models/panel-hub-configuration';
import { FilterConfig } from '../../../shared-components/panel-hub/models/filter-config';
import { SortField } from '../../../shared-components/panel-hub/models/sort-field';
import { PanelHubConstants } from '../../../shared-components/panel-hub/constants/panel-hub-constants';
import { PaginationConfigByFeature } from '../../../shared-components/panel-hub/constants/feature-pagination-configuration';
import { Features } from '../../../shared-components/panel-hub/enums/features.enum';
import { SessionQueryResult } from '../../models/session-query-result';
import { AppliedFilters } from '../../../shared-components/panel-hub/models/applied-filters';
import { PaginationState } from '../../../shared-components/panel-hub/models/pagination-state';
import { SortCriteria } from '../../../shared-components/panel-hub/models/sort-criteria';
import { SortDirection } from '../../../shared-components/panel-hub/enums/sort-direction.enum';
import { forkJoin, of } from 'rxjs';
import { switchMap, map, catchError, finalize } from 'rxjs/operators';
import { AssignmentGroupsRequest } from '../../../document/models/assignment-groups-request';
import { CourseDetail } from '../../models/courseDetails';
import { UsersService } from '../../../shared/services/users.service';
import { SessionManagementConstants } from '../../constants/session-management.constants';
import { PanelEventHub } from '../../../shared-components/panel-hub/models/panel-event-hub';
import { toOptions, toOptionsWithSort } from '../../../shared/utils';

@Component({
  selector: 'app-sesssion-management',
  templateUrl: './sesssion-management.component.html',
  styleUrls: ['./sesssion-management.component.scss']
})
export class SesssionManagementComponent {
  isSessionSliderOpen: boolean = false;
  isSessionAttendeeSliderOpen: boolean = false;
  @Input() courseInfoDetails!: CourseDetail;
  @Input() minimumPassingScore: string | null = null;
  @Input() ScoringOption: string | null = null;
  @Input() ProficiencyQuiz: string | null = null;

  courseDetails: any;
  isCourseInactive: boolean = false;
  isSessionManagementDataAvailable: boolean = false;
  courseSessionId: any;
  virtualMeetingURLText: string = CourseConstants.Virtual_MeetingURL_Text;
  infoForShowAllSession: string = CourseConstants.Show_All_Session_Info;
  attachmentsAvailable: boolean = false;
  isShowAllSelected: boolean = false;
  sessionAttachments: any;
  sliderAttendeeHeaderText: string = CourseConstants.Session_Attendee_Slider_Header_Text;
  noData: boolean = false;
  showSessionAuditModal: boolean = false;
  sessionIdForAudit: string = '';
  showLoader: boolean = false;
  currentPageSessions: SessionDetails[] = [];
  panelEventHub!: PanelEventHub
  panelHubConfig: PanelHubConfiguration = {
    title: "",
    feature: Features.SessionManagementView,
    standardFilterCount: PanelHubConstants.StandardFilterLength,
    showSelectAll: false,
    enableShowAllToggle: true,
    enableSelectAll: false,
    enableSelection: false,
    showAllLabel: CourseConstants.Show_All_Sessions_Label,
    showAllTooltip: CourseConstants.Show_All_Session_Info,
    enableToggling: false,
    enablePanelCardClick: false,
    enablePanelHighLight: false,
    enablePanelCardView: false,
    enableExport: false,
    enableExpandCollapse: false,
    enableViewModes: false,
    enableAssignmentView: false,
    enableWhereAmIUsedView: false,
    paginationConfig: PaginationConfigByFeature[Features.SessionManagementView]
  }
  pagedData: SessionQueryResult = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
  currentFilters: AppliedFilters | null = null;
  currentPagination: PaginationState | null = null;
  currentSort: SortCriteria | null = null;
  private hasInvalidDate: boolean = false;


  constructor(
    private courseService: CourseService,
    public datepipe: DatePipe,
    private coursePersistenceService: CoursePersistenceService,
    private commonService: CommonService,
    private messageService: MessageService,
    private userService: UsersService,
    private assignmentGroupService: AssignmentGroupService
  ) { }

  ngOnInit() {
    this.courseDetails = this.courseInfoDetails;
    this.isCourseInactive = this.courseDetails.status === CourseConstants.Course_Status_Inactive;

    this.loadFilterLookupSources();
    this.showInvalidDateWarning();

    this.coursePersistenceService.sessionUpdateData$.subscribe((resp: any) => {
      this.UpdateSessionDataWithUpdateInAttendee(resp);
    });

    this.courseService.closeAndResetSessionSlider$.subscribe((isClose) => {
      this.isSessionSliderOpen = isClose;
    });
  }

  UpdateSessionDataWithUpdateInAttendee(sessionDetails: SessionDetails) {
    this.pagedData.data.forEach((ele: SessionDetails) => {
      if (ele.sessionId == sessionDetails?.sessionId) {
        ele.attendees = sessionDetails?.attendees;
        ele.enrolledAttendees = sessionDetails?.enrolledAttendees;
      }
    });
  }

  sessionManagementDataReload(event: any) {
    this.getSessionData(event);
  }

  getSessionData(isRefresh: boolean) {
    if (isRefresh) {
      setTimeout(() => {
        this.resetPanelConfiguration();
        this.refreshPanelHubData();
      }, 2000);
    }
  }

  sessionCancelled(isCancelled: boolean) {
    if (isCancelled) {
      setTimeout(() => {
        this.resetPanelConfiguration();
        this.refreshPanelHubData();
      }, 2000);
    }
  }

  updateInSessionAttendee(isUpdate: boolean) {
    if (isUpdate) {
      setTimeout(() => {
        this.refreshPanelHubData();
      }, 4000);
    }
  }

  openSessionSlider() {
    this.isSessionSliderOpen = true;
    this.courseService.setCurrentSession(null);
    this.courseService.setSessionSliderStatus(false);
  }

  openSessionAttendeeSlider() {
    this.isSessionAttendeeSliderOpen = true;
    this.courseService.sessionAttendeeSlider$.next(false);
  }

  closeSessionAttendeeSlider(isSliderActive: boolean) {
    this.isSessionAttendeeSliderOpen = isSliderActive;
    this.courseService.sessionAttendeeSlider$.next(isSliderActive);
  }

  buildSpeedDialOptions(sessiondata: SessionDetails): any[] {
    const options = [];

    if (sessiondata?.sessionAuthorizationFlags?.isUserAuthorizedToCancel && sessiondata?.status === 'Scheduled') {
      options.push({
        tooltipOptions: { tooltipLabel: 'Cancel', tooltipPosition: 'left' },
        icon: 'pi pi-times',
        command: () => this.cancelSessionConfirmation(sessiondata.sessionId)
      });
    }

    if (sessiondata?.sessionAuthorizationFlags?.isAuditAccessible) {
      options.push({
        tooltipOptions: { tooltipLabel: 'Audit', tooltipPosition: 'left' },
        icon: 'pi pi-history',
        command: () => this.openSessionAuditModal(sessiondata.sessionId)
      });
    }

    if (
      sessiondata?.sessionAuthorizationFlags?.isUserAuthorizedToEnroll &&
      sessiondata?.enrollment === EnrollmentFormatsConstants.FormatName_Open
    ) {
      const enrollSessionData: EnrollSessionData = {
        format: this.courseDetails?.format,
        recommendedMaxAttendees: this.courseDetails?.recommendedMaxAttendees,
        prerequisites: this.courseDetails?.prerequisites || null,
        startDateTime: new Date(sessiondata.startDateAndTime)
      };

      options.push({
        tooltipOptions: { tooltipLabel: 'Enroll', tooltipPosition: 'left' },
        icon: 'fa fa-calendar-check',
        command: () => this.enrollSession(sessiondata.sessionId, enrollSessionData)
      });
    }

    if (sessiondata?.sessionAuthorizationFlags?.isUserAuthorizedToWithdraw) {
      options.push({
        tooltipOptions: { tooltipLabel: 'Withdrawal', tooltipPosition: 'left' },
        icon: 'fa fa-calendar-times',
        command: () => this.withdrawSession(sessiondata.sessionId, this.courseDetails?.recommendedMaxAttendees)
      });
    }

    if (sessiondata?.sessionAuthorizationFlags?.isUserAuthorizedToViewSessionAttendee) {
      options.push({
        tooltipOptions: { tooltipLabel: 'Attendees', tooltipPosition: 'left' },
        icon: 'fas fa-solid fa-users',
        command: () => this.openSessionAttendee(sessiondata.sessionId)
      });
    }

    if (sessiondata?.sessionAuthorizationFlags?.isUserAuthorizedToEdit && sessiondata?.status === 'Scheduled') {
      options.push({
        tooltipOptions: { tooltipLabel: 'Edit', tooltipPosition: 'left' },
        icon: 'pi pi-pencil',
        command: () => this.editSessionSlider(sessiondata)
      });
    }

    return options;
  }

  OpenVirtualMeeting(virtualMeetingURL: string) {
    window.open(virtualMeetingURL, "_blank");
  }
  OpenDocumentAttachmentModal(sessionId: any) {
    this.attachmentsAvailable = true;
    this.sessionAttachments = [];
    this.loadAttachments(sessionId);
  }
  openAttachmentModal(event: any) {
    this.attachmentsAvailable = event;
  }


  calculateStatusColor(status: string): string {
    let statusColor = '';
    switch (status) {
      case SessionStatusConstants.StatusName_Scheduled:
        statusColor = SessionStatusConstants.StatusClassName_Scheduled;
        break;
      case SessionStatusConstants.StatusName_Completed:
        statusColor = SessionStatusConstants.StatusClassName_Completed;
        break;
      case SessionStatusConstants.StatusName_Cancelled:
        statusColor = SessionStatusConstants.StatusClassName_Cancelled;
        break;
    }
    return statusColor;
  }
  calculateEnrollmentColor(enrollment: string): string {
    let enrollmentColor = '';
    switch (enrollment) {
      case EnrollmentFormatsConstants.FormatName_Open:
        enrollmentColor = EnrollmentFormatsConstants.FormatClassName_Open;
        break;
      case EnrollmentFormatsConstants.FormatName_Closed:
        enrollmentColor = EnrollmentFormatsConstants.FormatClassName_Closed;
        break;
    }
    return enrollmentColor;
  }

  calculateAttendeeColor(enrollmentCount: number, sessionEnrollment: any): string {
    if (sessionEnrollment == EnrollmentFormatsConstants.FormatName_Closed)
      return EnrollmentFormatsConstants.FormatClassName_Closed;
    return enrollmentCount < this.courseDetails.recommendedMaxAttendees ? EnrollmentFormatsConstants.FormatClassName_PartialFilled : EnrollmentFormatsConstants.FormatClassName_full;
  }

  openSessionAttendee(sessionInfo: any) {
    this.courseSessionId = sessionInfo;
    this.isSessionAttendeeSliderOpen = true;
    this.sliderAttendeeHeaderText = CourseConstants.Session_Attendee_Slider_Header_Text;
    this.courseService.sessionAttendeeSlider$.next(true);
    this.courseService.sessionId$.next(sessionInfo);
  }

  editSessionSlider(sessionInfo: SessionDetails) {
    this.courseService.setCurrentSession(sessionInfo);
    this.courseSessionId = sessionInfo.sessionId;
    this.isSessionSliderOpen = true;
    this.courseService.setSessionSliderStatus(true);
    this.courseService.sessionId$.next(sessionInfo.sessionId);

  }

  cancelSessionConfirmation(sessionId: any) {
    this.coursePersistenceService.openConfirmationDialogForCancelSession(sessionId);
    this.sessionCancelled(true);
    this.courseService.closeAndResetSessionSlider$.next(false);
  }

  enrollSession(sessionId: any, enrollSessionData: EnrollSessionData) {
    this.coursePersistenceService.openConfirmationDialogForEnrollment(sessionId, enrollSessionData);
    this.updateInSessionAttendee(true);
    this.coursePersistenceService.enrolledSession$.next(false);
  }

  withdrawSession(sessionId: any, recommendedMaxAttendee: any) {
    this.coursePersistenceService.openConfirmationDialogForWithdrawn(sessionId, recommendedMaxAttendee);
    this.updateInSessionAttendee(true);
    this.coursePersistenceService.withdrawSession$.next(false);
  }

  private loadAttachments(sessionId: any) {
    this.sessionAttachments = this.currentPageSessions.find((session: SessionDetails) => session.sessionId === sessionId)?.attachments;
  }


  //Safe formatter method
  safeFormatDate(data: any): string {
    try {
      if (!data) {
        this.hasInvalidDate = true;
        return 'Invalid date/time';
      }

      const start = this.commonService.parseCustomDate(data.startDateAndTime);
      const end = this.commonService.parseCustomDate(data.endDateAndTime);

      if (!start || !end) {
        this.hasInvalidDate = true;
        return 'Invalid date/time';
      }

      const sameDay = start.toDateString() === end.toDateString();
      const timeFmt = data.timeFormat !== undefined && data.timeFormat !== null ? ` (${data.timeFormat})` : '';

      const fmtDate = (d: Date) =>
        d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
      const fmtTime = (d: Date) =>
        d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false });

      if (sameDay) {
        return `${fmtDate(start)}, ${fmtTime(start)} - ${fmtTime(end)}${timeFmt}`;
      } else {
        return `${fmtDate(start)}, ${fmtTime(start)} - ${fmtDate(end)}, ${fmtTime(end)}${timeFmt}`;
      }
    } catch (err) {
      console.error('safeFormatDate error:', err);
      this.hasInvalidDate = true;
      return 'Invalid date/time';
    }
  }

  // Main date-time display method
  setDateTime(data: any): string {
    try {
      if (!data) return 'Invalid date/time';

      const start = this.commonService.parseCustomDate(data.startDateAndTime);
      const end = this.commonService.parseCustomDate(data.endDateAndTime);

      if (!start || !end) return 'Invalid date/time';

      const startDateTime = this.updateDateAndTime(start);
      const endDateTime = this.updateDateAndTime(end);

      const startDate = new Date(startDateTime);
      const endDate = new Date(endDateTime);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) return 'Invalid date/time';

      const timeFormat = data.timeFormat !== undefined && data.timeFormat !== null ? ` (${data.timeFormat})` : '';

      const fmtDateTime = (d: Date) =>
        d.toLocaleString('en-GB', {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });

      const sameDay = startDate.toDateString() === endDate.toDateString();

      if (sameDay) {
        const startDateStr = fmtDateTime(startDate);
        const endTimeStr = endDate.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        });
        return `${fmtDateTime(startDate).split(',')[0]}, ${startDate.toLocaleTimeString('en-GB', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        })} - ${endTimeStr}${timeFormat}`;
      } else {
        return `${fmtDateTime(startDate)} - ${fmtDateTime(endDate)}${timeFormat}`;
      }
    } catch (err) {
      console.error('setDateTime error:', err);
      return 'Invalid date/time';
    }
  }

  openSessionAuditModal = (sessionId: string) => {
    this.sessionIdForAudit = sessionId;
    this.showSessionAuditModal = true;
  }
  closeSessionAuditModal = (isModalOpen: boolean) => {
    this.sessionIdForAudit = '';
    this.showSessionAuditModal = isModalOpen;
  }



  updateDateAndTime(dateTime: Date) {
    // Combine date and time into one string
    const dateTimeString = this.formatDateTimeToISOString(dateTime);
    return dateTimeString;
  }

  formatDateTimeToISOString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  onPanelEventHubInitialized(event: PanelEventHub) {
    this.panelEventHub = event;
  }

  onPanelHubStateChanged = (event: PanelHubStateChangedEvent) => {
    switch (event.type) {
      case PanelHubEventType.FilterChanged:
        this.currentFilters = event.state.filters || null;
        if (this.currentPagination) this.currentPagination.pageNumber = 1;
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.SortChanged:
        this.currentSort = event.state.sort || null;
        if (this.currentPagination) this.currentPagination.pageNumber = 1;
        this.refreshPanelHubData();
        break;

      case PanelHubEventType.PaginationChanged:
        this.currentPagination = event.state.pagination || null;
        this.refreshPanelHubData();
        break;

      case PanelHubEventType.SelectAllToggled:
      case PanelHubEventType.ItemSelectionChanged:
        break;
      case PanelHubEventType.ShowAllChanged:
        this.isShowAllSelected = event.state.isShowAllChanged || false;
        this.resetPanelConfiguration();
        this.refreshPanelHubData();
        break;
    }
  }

  resetPanelConfiguration = () => {
    this.currentPagination = {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };
    this.currentFilters = null;
    this.currentSort = null;
    if (this.panelEventHub) {
      this.panelEventHub.resetConfigurations();
    }
  }

  private loadFilterLookupSources() {
    this.initializePanelHub();
  }

  private initializePanelHub() {
    this.showLoader = true;
    const assignmentGroupsRequest = this.buildAssignmentGroupsRequest();

    forkJoin(this.fetchLookupSources(assignmentGroupsRequest)).pipe(
      switchMap(results => {
        const users = results.users as any[];
        const assignmentGroups = results.assignmentGroups as any[];
        const sessionLookup = results.sessionLookup as any;
        const filterConfigs = this.buildFilterConfigs(users, assignmentGroups, sessionLookup);
        const sortOptions = this.buildSortOptions();
        this.setPanelHubConfigExtensions([...filterConfigs], sortOptions);
        return this.fetchInitialPagedSessions().pipe(
          map(paged => ({ paged }))
        );
      }),
      catchError(err => {
        this.handleInitError();
        return of(null);
      }),
      finalize(() => {
        this.showLoader = false;
        this.showInvalidDateWarning();
      })
    ).subscribe(result => {
      if (!result) return;
      this.applyPagedResult(result.paged);
      this.isSessionManagementDataAvailable = true;
    });
  }

  private fetchLookupSources(assignmentGroupsRequest: AssignmentGroupsRequest) {
    return {
      users: this.userService.getUsers(),
      sessionLookup: this.courseService.getSessionMasterData(),
      assignmentGroups: this.assignmentGroupService.getAssignmentGroups(assignmentGroupsRequest)
    };
  }

  private buildAssignmentGroupsRequest(): AssignmentGroupsRequest {
    const scopes: string[] = Array.isArray(this.courseDetails?.eqmsScopes) ? this.courseDetails.eqmsScopes.map((s: any) => String(s)) : [];
    const assignmentTypes: number[] = [
      CourseConstants.AssignmentGroup_QualifiedTrainerAssignment,
      CourseConstants.AssignmentGroup_CourseOwnerAssignment
    ];
    return new AssignmentGroupsRequest(scopes, assignmentTypes);
  }

  private buildFilterConfigs(users: readonly any[] = [],
    assignmentGroups: readonly any[] = [],
    sessionLookup: any = {}
  ): readonly FilterConfig[] {
    const trainerOptions = [...toOptionsWithSort(users, 'name', 'name')];
    const assignmentGroupOptions = [...toOptionsWithSort(assignmentGroups, 'name', 'name')];
    const mergedTrainerOptions = [...trainerOptions, ...assignmentGroupOptions];
    const formatOptions = [...toOptions(sessionLookup.format, 'name', 'value')];
    const statusOptions = [...toOptions(sessionLookup.statuses, 'name', 'value')];
    const enrollmentOptions = [...toOptions(sessionLookup.enrollment, 'name', 'value')];
    return [
      { displayName: 'Trainers', fieldName: 'Trainers', options: mergedTrainerOptions },
      { displayName: 'Format', fieldName: 'Format', options: formatOptions },
      { displayName: 'Status', fieldName: 'Status', options: statusOptions },
      { displayName: 'Enrollment', fieldName: 'Enrollment', options: enrollmentOptions }
    ].filter(fc => fc.options.length > 0);
  }



  private ensureDefaultSort() {
    if (!this.currentSort) {
      this.currentSort = { field: 'StartDateAndTime', sortDirection: SortDirection.Ascending };
    }
  }
  private refreshPanelHubData() {
    if (!this.currentPagination) {
      this.currentPagination = {
        pageNumber: this.panelHubConfig.paginationConfig.startPage,
        pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
        totalRecords: 0
      };
    }
    this.fetchPagedSessionData();
  }

  private fetchPagedSessionData() {
    if (!this.currentPagination) return;
    this.panelEventHub.startLoader();
    this.courseService.querySessionManagementData(
      this.courseDetails.courseNumber,
      this.isShowAllSelected,
      this.currentPagination,
      this.currentFilters,
      this.currentSort
    ).pipe(
      map(result => ({ result })),
      catchError(err => {
        this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
        this.noData = true;
        this.messageService.add({
          severity: SessionManagementConstants.Severity_Err,
          summary: SessionManagementConstants.TECHNICAL_ERROR_ON_SESSIONS_LOAD,
          sticky: true
        });
        return of(null);
      }),
      finalize(() => {
        this.panelEventHub.stopLoader();
        this.showInvalidDateWarning();
      })
    ).subscribe(res => {
      if (!res) return;
      this.applyQueryResult(res.result);
    });
  }

  private buildSortOptions(): SortField[] {
    return [
      { fieldDisplayName: 'Trainers', fieldName: 'Trainers' },
      { fieldDisplayName: 'Format', fieldName: 'Format' },
      { fieldDisplayName: 'Status', fieldName: 'Status' },
      { fieldDisplayName: 'Enrollment', fieldName: 'Enrollment' },
      { fieldDisplayName: 'Start Date', fieldName: 'StartDateAndTime' },
      { fieldDisplayName: 'End Date', fieldName: 'EndDateAndTime' },
    ];
  }

  private setPanelHubConfigExtensions(filterConfigs: FilterConfig[], sortOptions: SortField[]) {
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
  }


  private fetchInitialPagedSessions() {
    const paginationState: PaginationState = {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };
    return this.courseService.querySessionManagementData(
      this.courseDetails.courseNumber,
      false,
      paginationState,
      null,
      null
    );
  }

  private enrichSession(session: any) {
    const trainersList = Array.isArray(session.trainers)
      ? session.trainers.map((t: any) => t?.assignedUserName).filter((n: any) => !!n)
      : [];
    return {
      ...session,
      trainersList,
      displayDateTime: this.safeFormatDate(session),
      speedDialOptions: this.buildSpeedDialOptions(session)
    };
  }

  private transformSessions(list: any[] | null | undefined): any[] {
    if (!Array.isArray(list) || list.length === 0) return [];
    return list.map(s => this.enrichSession(s));
  }

  private initPagination(totalRecords: number): PaginationState {
    return {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords
    };
  }

  private applyPagedResult(result: SessionQueryResult) {
    const processed = this.transformSessions(result.data);
    this.pagedData = { totalRecords: result.totalRecords, data: processed, pageNumber: result.pageNumber ?? 1, pageSize: result.pageSize ?? 0 };
    this.currentPageSessions = processed;
    this.noData = processed.length === 0;
    this.currentPagination = this.initPagination(result.totalRecords);

  }

  private handleInitError() {
    this.isSessionManagementDataAvailable = false;
    this.showLoader = false;
    this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
    this.noData = true;
    this.messageService.add({
      severity: SessionManagementConstants.Severity_Err,
      summary: SessionManagementConstants.TECHNICAL_ERROR_ON_SESSIONS_LOAD,
      sticky: true
    });
  }

  private applyQueryResult(result: SessionQueryResult) {
    const processed = this.transformSessions(result.data);
    this.pagedData = { totalRecords: result.totalRecords, data: processed, pageNumber: result.pageNumber ?? 1, pageSize: result.pageSize ?? 0 };
    this.currentPageSessions = processed;
    this.noData = processed.length === 0;
    if (this.currentPagination) this.currentPagination.totalRecords = result.totalRecords;
  }

  private showInvalidDateWarning() {
    if (this.hasInvalidDate) {
      this.messageService.add({
        severity: CourseConstants.Severity_Warning,
        summary: CourseConstants.Invalid_Date_Format_Warning,
      });
    }
  }
}
